__turbopack_context__.v({
  "bx": "Button-module__PTUFWG__bx",
  "lc-button": "Button-module__PTUFWG__lc-button",
  "lc-icon-button": "Button-module__PTUFWG__lc-icon-button",
});
